export const SEARCH_BUTTON_WIDTH = 300;
export const SEARCH_BOX_HEIGHT = 600;
export const SEARCH_BOX_WIDTH = 600;
export const SEARCH_BOX__SEARCH_GUIDE_HEIGHT = 70;
export const SEARCH_BOX__SEARCH_INPUT_HEIGHT = 92;
export const SEARCH_BOX__SEARCH_RESULT_HEIGHT = 70;
export const SEARCH_BOX__SEARCH_RESULT_LIST_HEIGHT_TOP_MARGIN = 16;
export const SEARCH_BOX__SEARCH_RESULT_LIST_HEIGHT =
	SEARCH_BOX_HEIGHT -
	SEARCH_BOX__SEARCH_INPUT_HEIGHT -
	SEARCH_BOX__SEARCH_GUIDE_HEIGHT -
	SEARCH_BOX__SEARCH_RESULT_LIST_HEIGHT_TOP_MARGIN;

export const searchInputStyles = {
	display: 'flex',
	alignItems: 'center',
	pl: 3,
	pr: 3,
	pt: 3,
};

export const modalStyles = {
	position: 'absolute' as const,
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: {
		xs: '90%',
		sm: '90%',
		md: SEARCH_BOX_WIDTH,
		lg: SEARCH_BOX_WIDTH,
		xl: SEARCH_BOX_WIDTH,
	},
	height: SEARCH_BOX_HEIGHT,
	bgcolor: 'background.paper',
	borderRadius: 4,
};

export const searchButtonStyles = {
	bgcolor: 'white.lightest',
	display: 'flex',
	alignItems: 'center',
	color: 'text.primary',
	pl: 1,
	pr: 1,
	mr: 1,
	width: SEARCH_BUTTON_WIDTH,
	borderRadius: 1,
	justifyContent: 'space-between',
	// hover stuff
	':hover': {
		bgcolor: 'white.light',
	},
};

export const searchResultsStyles = {
	p: 0,
	mt: `${SEARCH_BOX__SEARCH_RESULT_LIST_HEIGHT_TOP_MARGIN}px`,
	overflow: 'hidden',
	overflowY: 'auto',
	height: SEARCH_BOX__SEARCH_RESULT_LIST_HEIGHT,
	'::-webkit-scrollbar': {
		display: 'none',
	},
};

export const searchModalHelpStyles = {
	typography: 'captionMedium',
	display: 'flex',
	alignItems: 'center',
	height: SEARCH_BOX__SEARCH_GUIDE_HEIGHT,
	pl: 3,
	pr: 3,
};
